export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/mysql.883cfa4.svg";